"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrFindUser = void 0;
const uuid_1 = require("uuid");
const agents_1 = require("../agents");
const sendEmail_1 = require("../sendEmail");
const helpers_1 = require("../../helpers");
const site_1 = require("../site");
const createOrFindUser = async ({ supabase, agent_id, email, first_name, last_name, phone, user_type, country_of_residence, display_currency, site_id = "d2cc0624-ec2f-4446-ab5f-742195db73c0", }) => {
    const { data, error } = await supabase
        .rpc("check_account_exists", {
        email_address: email.toLowerCase(),
    })
        .single();
    const user = data;
    let client;
    if (!user.exists) {
        const password = (0, uuid_1.v4)().substring(0, 8);
        // does the user exist already.  If the user is already in the system we just need to add the order to their account rather than creating an account.
        await supabase.auth.admin.createUser({
            email: email,
            password: password,
            email_confirm: true,
            user_metadata: {
                first_name: first_name,
                last_name: last_name,
                country_of_residence: country_of_residence,
                phone_number: phone,
                user_type: user_type,
                display_currency: display_currency,
            },
        });
        // get the new user
        const { data: user_profile, error: user_error } = await supabase
            .from("user_profiles")
            .select("*")
            .eq("email", email.toLowerCase())
            .single();
        client = user_profile;
        // if its a client send the welcome email dont send if its a guest
        if (user_type === "client") {
            let agent = {};
            if (agent_id) {
                agent = await (0, agents_1.getAgentById)(supabase, agent_id);
            }
            let site = {};
            if (site_id) {
                site = await (0, site_1.getSiteById)(supabase, site_id);
            }
            // send welcome email if a new user
            const new_account_email = {
                language_code: "en",
                template_id: helpers_1.CREATE_ACCOUNT_TEMP_PASSWORD,
                data: {
                    password: password,
                    client: user_profile,
                    agent: agent,
                    site: site,
                },
            };
            await (0, sendEmail_1.sendEmail)(new_account_email);
        }
    }
    else {
        const { data: user_profile, error } = await supabase
            .from("user_profiles")
            .select("*")
            .eq("email", email.toLowerCase())
            .single();
        let has_update = false;
        if ((user_profile?.first_name === null ||
            user_profile?.first_name === "" ||
            user_profile?.first_name === undefined) &&
            first_name) {
            has_update = true;
            user_profile.first_name = first_name;
        }
        if ((user_profile?.last_name === null ||
            user_profile?.last_name === "" ||
            user_profile?.last_name === undefined) &&
            last_name) {
            has_update = true;
            user_profile.last_name = last_name;
        }
        if ((user_profile?.phone === null ||
            user_profile?.phone === "" ||
            user_profile?.phone === undefined) &&
            phone) {
            has_update = true;
            user_profile.phone = phone;
        }
        if ((user_profile?.country_of_residence === null ||
            user_profile?.country_of_residence === "" ||
            user_profile?.country_of_residence === undefined) &&
            country_of_residence) {
            has_update = true;
            user_profile.country_of_residence = country_of_residence;
        }
        if (user_profile?.user_type === null ||
            user_profile?.user_type === "" ||
            user_profile?.user_type === undefined) {
            has_update = true;
            user_profile.user_type = "client";
        }
        if ((user_profile?.display_currency === null ||
            user_profile?.display_currency === "" ||
            user_profile?.display_currency === undefined) &&
            display_currency) {
            has_update = true;
            user_profile.display_currency = display_currency;
        }
        if (has_update) {
            await supabase.from("user_profiles").upsert([user_profile]).single();
        }
        client = user_profile;
    }
    return client;
};
exports.createOrFindUser = createOrFindUser;
